<template>
  <div>
    <template v-if="isButtonVisible">
      <add-to-cart-parent
        :data="data"
        :added_to_cart="added_to_cart"
        :label_add_to_cart="label_add_to_cart"
        :netsuite_url="netsuite_url"
        :netsuite_id="netsuite_id"
        :components="components"
        :item_id="stockCode"
        :item_name="product_title"
        :item_category="product_category"
        :price="price"
        :netsuite_app_url="netsuite_app_url"
        :dealer_set="dealer_set"
        :label_added_to_cart="label_added_to_cart"
        :label_adding_to_cart="label_adding_to_cart"
        :label_view_cart="label_view_cart"
        :label_continue_shopping="label_continue_shopping"
        :sitekey="sitekey"
        :netsuite_parent_id="netsuite_parent_id"
        :package_components="package_components"
        :parent_status="parent_status"
        :parent_isinstock="parent_isinstock"
        :parent_isbackorderable="parent_isbackorderable"
        :childactivestatus="childactivestatus"
        :childbackorderablestatus="childbackorderablestatus"
        :is_stock_waitlist_active="is_stock_waitlist_active"
        :is_spare_part_enabled="is_spare_part_enabled"
        :is_always_in_stock="is_always_in_stock"
        :cart_url="cart_url"
      >
      </add-to-cart-parent>
    </template>
    <template v-else>
      <wish-list-add-button
        v-if="showWishlistButton"
        :data="data"
        :add_to_wishlist="add_to_wishlist"
        :added_to_wishlist="added_to_wishlist"
        :label_view_wishlist="label_view_wishlist"
        :label_continue_shopping="label_continue_shopping"
        :enable_b2c="enable_b2c"
        :enable_b2b="enable_b2b"
        :netsuite_url="netsuite_url"
        :netsuite_app_url="netsuite_app_url"
        :dealer_set="dealer_set"
      >
      </wish-list-add-button>
      <find-a-dealer-button
        v-if="
          is_a_dealer === '0' &&
          (lng_id === '7' || lng_id === '2') &&
          showWishlistButton
        "
        :data="data"
        :add_to_wishlist="add_to_wishlist"
        :added_to_wishlist="added_to_wishlist"
        :label_view_wishlist="label_view_wishlist"
        :label_find_a_dealer="label_find_a_dealer"
        :label_continue_shopping="label_continue_shopping"
        :enable_b2c="enable_b2c"
        :enable_b2b="enable_b2b"
        :netsuite_url="netsuite_url"
        :netsuite_app_url="netsuite_app_url"
        :dealer_set="dealer_set"
      >
      </find-a-dealer-button>
    </template>
  </div>
</template>


<script>
import { getCartUrl, intToBool } from "../store/modules/helpers";

export default {
  name: "product-header-items",
  props: {
    data: {
      type: Object,
      required: true,
    },
    added_to_cart: {
      type: String,
      required: true,
    },
    label_add_to_cart: {
      type: String,
      required: true,
    },
    label_find_a_dealer: {
      type: String,
      required: true,
    },
    label_adding_to_cart: {
      type: String,
      default: "Adding to Cart",
    },
    netsuite_url: {
      type: String,
      required: true,
    },
    item_brand: {
      type: String,
      default: "Rhinorack"
    },
    netsuite_parent_id :{
      type: String,
    },
    netsuite_id: {
      type: String,
      required: true,
    },
    package_components: {
      type: String
    },
    parent_status: {
      type: String
    },
    parent_isinstock: {
      type: String
    },
    parent_isbackorderable: {
      type: String
    },
    childactivestatus: {
      type: String
    },
    childbackorderablestatus: {
      type: String
    },
    components: {
      type: Array,
      required: true,
    },
    category: {
      type: Object
    },
    price: {
      type: Number,
      required: true
    },
    stockCode: {
      type: String
    },
    sitekey:{
      type: String
    },
    netsuite_app_url: {
      type: String,
      required: true,
    },
    product_id: {
      type: String
    },
    dealer_set: {
      type: Boolean,
      required: true,
    },
    is_stock_waitlist_active: {
      type: String
    },
    is_spare_part_enabled: {
      type: String
    },
    is_always_in_stock: {
      type: String
    },
    label_added_to_cart: {
      type: String,
      required: true,
    },
    added_to_wishlist: {
      type: String,
      required: true,
    },
    add_to_wishlist: {
      type: String,
      required: true,
    },
    label_view_wishlist: {
      type: String,
      required: true,
    },
    label_adding_to_cart: {
      type: String,
      required: true,
    },
    label_view_cart: {
      type: String,
      default: "View Cart",
    },
    label_continue_shopping: {
      type: String,
      default: "Continue Shopping",
    },
    is_always_in_stock: {
      type: String,
      default: "0",
    },
    is_a_dealer: {
      type: String,
      required: true,
    },
    lng_id: {
      type: String,
      required: true,
    },
    product_title: {
      type: String
    },
    cart_url: {
      type: String
    },
    enable_b2c: {},
    enable_b2b: {},
  },
  data() {
    return {
      cartmode: false,
      isDisabled: false,
      added: false,
      item: null,
      currency: window.currency,
      showModal: false,
      ns_session_var: window.ns_session_var,
      tax: window.tax,
      culture: window.culture,
      country: window.country,
      showWishlistButton: false,
      product_category: '',
    };
  },
  mounted() {
    this.filterCategory();
    this.applyStockConditions();
    this.fetchProductDetails();
    setTimeout(() => {
      this.showWishlistButton = true;
    }, 1500);
  },
  methods: {
    async fetchProductDetails() {
      let apiData = await axios.get(this.cartUrl, { withCredentials: true });
      this.$store.commit("cart/setApiData", apiData.data);
    },
    applyStockConditions() {
      // console.log('Parent data',this.data);
      this.$store.commit("cart/setNetsuiteId", this.data.netSuiteId);
      this.$store.commit("cart/setStockCode", this.data.stockCode);
      this.$store.commit(
        "cart/checkPackageWithoutComponents",
        this.is_always_in_stock
      );
    },
    filterCategory(){
      if (this.category && this.category.title) {
        this.product_category = this.category.title;
      }
    }
  },
  computed: {
    isButtonVisible() {
      if (this.data.packagecomponents == 1) {
        return false;
      }
      return this.$store.getters["cart/isAddToCartButtonVisible"]();
    },
    cartUrl() {
      return getCartUrl(this.netsuite_url, this.netsuite_id, this.components);
    },
  },
};
</script>
